var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMana10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-296.29 166.79)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6 0 0 6 5966.3 463.23)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -895,
    cy: -55.002,
    r: 50,
    fill: "#cac5c0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m508.13-54.976v302.63c0 35.988 15.402 53.988 46.158 53.988h7.8302v20.52h-161.2v-20.52h10.362c29.586 0 44.4-18 44.4-53.988v-198.48c0-36.48-12.93-54.738-38.802-54.738h-15.96v-20.544h6.0961c31.428 0 59.814-9.624 85.146-28.878l15.966 0.0067zm58.56 199.97c0-47.142 9.8763-90.492 29.64-130.01 24.852-49.158 58.83-73.758 101.89-73.758 41.586 0 74.532 21.048 98.856 63.096 19.776 34.488 29.67 74.286 29.67 119.39 0 47.154-9.8881 90.234-29.67 129.27-24.846 48.174-58.542 72.246-101.12 72.246-41.052 0-73.759-20.79-98.112-62.37-20.784-34.968-31.158-74.256-31.158-117.86zm54.732-22.056c0 40.08 4.3083 76.056 12.936 107.98 13.182 49.17 34.71 73.77 64.626 73.77 48.666 0 72.99-50.682 72.99-152.08 0-125.21-26.364-187.81-79.092-187.81-47.646 0-71.472 48.63-71.472 145.97v12.168z",
    fill: "#0d0f0f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMana10);
export default __webpack_public_path__ + "static/media/mana10.493defb71d0140bfdf546f8a7e9ef924.svg";
export { ForwardRef as ReactComponent };